import _inherits from "/home/runner/work/soroban-rpc-api/soroban-rpc-api/build/docs/gatsby/node_modules/@babel/runtime/helpers/esm/inherits";
import _possibleConstructorReturn from "/home/runner/work/soroban-rpc-api/soroban-rpc-api/build/docs/gatsby/node_modules/@babel/runtime/helpers/esm/possibleConstructorReturn";
import _getPrototypeOf from "/home/runner/work/soroban-rpc-api/soroban-rpc-api/build/docs/gatsby/node_modules/@babel/runtime/helpers/esm/getPrototypeOf";
import _slicedToArray from "/home/runner/work/soroban-rpc-api/soroban-rpc-api/build/docs/gatsby/node_modules/@babel/runtime/helpers/esm/slicedToArray";
import _classCallCheck from "/home/runner/work/soroban-rpc-api/soroban-rpc-api/build/docs/gatsby/node_modules/@babel/runtime/helpers/esm/classCallCheck";
import _createClass from "/home/runner/work/soroban-rpc-api/soroban-rpc-api/build/docs/gatsby/node_modules/@babel/runtime/helpers/esm/createClass";

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }

function _createForOfIteratorHelper(o, allowArrayLike) { var it = typeof Symbol !== "undefined" && o[Symbol.iterator] || o["@@iterator"]; if (!it) { if (Array.isArray(o) || (it = _unsupportedIterableToArray(o)) || allowArrayLike && o && typeof o.length === "number") { if (it) o = it; var i = 0; var F = function F() {}; return { s: F, n: function n() { if (i >= o.length) return { done: true }; return { done: false, value: o[i++] }; }, e: function e(_e) { throw _e; }, f: F }; } throw new TypeError("Invalid attempt to iterate non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); } var normalCompletion = true, didErr = false, err; return { s: function s() { it = it.call(o); }, n: function n() { var step = it.next(); normalCompletion = step.done; return step; }, e: function e(_e2) { didErr = true; err = _e2; }, f: function f() { try { if (!normalCompletion && it.return != null) it.return(); } finally { if (didErr) throw err; } } }; }

function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }

function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) { arr2[i] = arr[i]; } return arr2; }

/*---------------------------------------------------------------------------------------------
 *  Copyright (c) Microsoft Corporation. All rights reserved.
 *  Licensed under the MIT License. See License.txt in the project root for license information.
 *--------------------------------------------------------------------------------------------*/
var __decorate = this && this.__decorate || function (decorators, target, key, desc) {
  var c = arguments.length,
      r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc,
      d;
  if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);else for (var i = decorators.length - 1; i >= 0; i--) {
    if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
  }
  return c > 3 && r && Object.defineProperty(target, key, r), r;
};

var __param = this && this.__param || function (paramIndex, decorator) {
  return function (target, key) {
    decorator(target, key, paramIndex);
  };
};

import * as nls from '../../../nls.js';
import * as dom from '../../../base/browser/dom.js';
import { Separator, SubmenuAction } from '../../../base/common/actions.js';
import { DisposableStore } from '../../../base/common/lifecycle.js';
import { EditorAction, registerEditorAction, registerEditorContribution } from '../../browser/editorExtensions.js';
import { EditorContextKeys } from '../../common/editorContextKeys.js';
import { IMenuService, MenuId, SubmenuItemAction } from '../../../platform/actions/common/actions.js';
import { IContextKeyService } from '../../../platform/contextkey/common/contextkey.js';
import { IContextMenuService, IContextViewService } from '../../../platform/contextview/browser/contextView.js';
import { IKeybindingService } from '../../../platform/keybinding/common/keybinding.js';
import { ActionViewItem } from '../../../base/browser/ui/actionbar/actionViewItems.js';

var ContextMenuController = /*#__PURE__*/function () {
  function ContextMenuController(editor, _contextMenuService, _contextViewService, _contextKeyService, _keybindingService, _menuService) {
    var _this = this;

    _classCallCheck(this, ContextMenuController);

    this._contextMenuService = _contextMenuService;
    this._contextViewService = _contextViewService;
    this._contextKeyService = _contextKeyService;
    this._keybindingService = _keybindingService;
    this._menuService = _menuService;
    this._toDispose = new DisposableStore();
    this._contextMenuIsBeingShownCount = 0;
    this._editor = editor;

    this._toDispose.add(this._editor.onContextMenu(function (e) {
      return _this._onContextMenu(e);
    }));

    this._toDispose.add(this._editor.onMouseWheel(function (e) {
      if (_this._contextMenuIsBeingShownCount > 0) {
        var view = _this._contextViewService.getContextViewElement();

        var target = e.srcElement; // Event triggers on shadow root host first
        // Check if the context view is under this host before hiding it #103169

        if (!(target.shadowRoot && dom.getShadowRoot(view) === target.shadowRoot)) {
          _this._contextViewService.hideContextView();
        }
      }
    }));

    this._toDispose.add(this._editor.onKeyDown(function (e) {
      if (e.keyCode === 58
      /* ContextMenu */
      ) {
        // Chrome is funny like that
        e.preventDefault();
        e.stopPropagation();

        _this.showContextMenu();
      }
    }));
  }

  _createClass(ContextMenuController, [{
    key: "_onContextMenu",
    value: function _onContextMenu(e) {
      if (!this._editor.hasModel()) {
        return;
      }

      if (!this._editor.getOption(15
      /* contextmenu */
      )) {
        this._editor.focus(); // Ensure the cursor is at the position of the mouse click


        if (e.target.position && !this._editor.getSelection().containsPosition(e.target.position)) {
          this._editor.setPosition(e.target.position);
        }

        return; // Context menu is turned off through configuration
      }

      if (e.target.type === 12
      /* OVERLAY_WIDGET */
      ) {
        return; // allow native menu on widgets to support right click on input field for example in find
      }

      e.event.preventDefault();

      if (e.target.type !== 6
      /* CONTENT_TEXT */
      && e.target.type !== 7
      /* CONTENT_EMPTY */
      && e.target.type !== 1
      /* TEXTAREA */
      ) {
        return; // only support mouse click into text or native context menu key for now
      } // Ensure the editor gets focus if it hasn't, so the right events are being sent to other contributions


      this._editor.focus(); // Ensure the cursor is at the position of the mouse click


      if (e.target.position) {
        var hasSelectionAtPosition = false;

        var _iterator = _createForOfIteratorHelper(this._editor.getSelections()),
            _step;

        try {
          for (_iterator.s(); !(_step = _iterator.n()).done;) {
            var selection = _step.value;

            if (selection.containsPosition(e.target.position)) {
              hasSelectionAtPosition = true;
              break;
            }
          }
        } catch (err) {
          _iterator.e(err);
        } finally {
          _iterator.f();
        }

        if (!hasSelectionAtPosition) {
          this._editor.setPosition(e.target.position);
        }
      } // Unless the user triggerd the context menu through Shift+F10, use the mouse position as menu position


      var anchor = null;

      if (e.target.type !== 1
      /* TEXTAREA */
      ) {
        anchor = {
          x: e.event.posx - 1,
          width: 2,
          y: e.event.posy - 1,
          height: 2
        };
      } // Show the context menu


      this.showContextMenu(anchor);
    }
  }, {
    key: "showContextMenu",
    value: function showContextMenu(anchor) {
      if (!this._editor.getOption(15
      /* contextmenu */
      )) {
        return; // Context menu is turned off through configuration
      }

      if (!this._editor.hasModel()) {
        return;
      }

      if (!this._contextMenuService) {
        this._editor.focus();

        return; // We need the context menu service to function
      } // Find actions available for menu


      var menuActions = this._getMenuActions(this._editor.getModel(), MenuId.EditorContext); // Show menu if we have actions to show


      if (menuActions.length > 0) {
        this._doShowContextMenu(menuActions, anchor);
      }
    }
  }, {
    key: "_getMenuActions",
    value: function _getMenuActions(model, menuId) {
      var result = []; // get menu groups

      var menu = this._menuService.createMenu(menuId, this._contextKeyService);

      var groups = menu.getActions({
        arg: model.uri
      });
      menu.dispose(); // translate them into other actions

      var _iterator2 = _createForOfIteratorHelper(groups),
          _step2;

      try {
        for (_iterator2.s(); !(_step2 = _iterator2.n()).done;) {
          var group = _step2.value;

          var _group = _slicedToArray(group, 2),
              actions = _group[1];

          var addedItems = 0;

          var _iterator3 = _createForOfIteratorHelper(actions),
              _step3;

          try {
            for (_iterator3.s(); !(_step3 = _iterator3.n()).done;) {
              var action = _step3.value;

              if (action instanceof SubmenuItemAction) {
                var subActions = this._getMenuActions(model, action.item.submenu);

                if (subActions.length > 0) {
                  result.push(new SubmenuAction(action.id, action.label, subActions));
                  addedItems++;
                }
              } else {
                result.push(action);
                addedItems++;
              }
            }
          } catch (err) {
            _iterator3.e(err);
          } finally {
            _iterator3.f();
          }

          if (addedItems) {
            result.push(new Separator());
          }
        }
      } catch (err) {
        _iterator2.e(err);
      } finally {
        _iterator2.f();
      }

      if (result.length) {
        result.pop(); // remove last separator
      }

      return result;
    }
  }, {
    key: "_doShowContextMenu",
    value: function _doShowContextMenu(actions) {
      var _this2 = this;

      var anchor = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : null;

      if (!this._editor.hasModel()) {
        return;
      } // Disable hover


      var oldHoverSetting = this._editor.getOption(46
      /* hover */
      );

      this._editor.updateOptions({
        hover: {
          enabled: false
        }
      });

      if (!anchor) {
        // Ensure selection is visible
        this._editor.revealPosition(this._editor.getPosition(), 1
        /* Immediate */
        );

        this._editor.render();

        var cursorCoords = this._editor.getScrolledVisiblePosition(this._editor.getPosition()); // Translate to absolute editor position


        var editorCoords = dom.getDomNodePagePosition(this._editor.getDomNode());
        var posx = editorCoords.left + cursorCoords.left;
        var posy = editorCoords.top + cursorCoords.top + cursorCoords.height;
        anchor = {
          x: posx,
          y: posy
        };
      } // Show menu


      this._contextMenuIsBeingShownCount++;

      this._contextMenuService.showContextMenu({
        domForShadowRoot: this._editor.getDomNode(),
        getAnchor: function getAnchor() {
          return anchor;
        },
        getActions: function getActions() {
          return actions;
        },
        getActionViewItem: function getActionViewItem(action) {
          var keybinding = _this2._keybindingFor(action);

          if (keybinding) {
            return new ActionViewItem(action, action, {
              label: true,
              keybinding: keybinding.getLabel(),
              isMenu: true
            });
          }

          var customActionViewItem = action;

          if (typeof customActionViewItem.getActionViewItem === 'function') {
            return customActionViewItem.getActionViewItem();
          }

          return new ActionViewItem(action, action, {
            icon: true,
            label: true,
            isMenu: true
          });
        },
        getKeyBinding: function getKeyBinding(action) {
          return _this2._keybindingFor(action);
        },
        onHide: function onHide(wasCancelled) {
          _this2._contextMenuIsBeingShownCount--;

          _this2._editor.focus();

          _this2._editor.updateOptions({
            hover: oldHoverSetting
          });
        }
      });
    }
  }, {
    key: "_keybindingFor",
    value: function _keybindingFor(action) {
      return this._keybindingService.lookupKeybinding(action.id);
    }
  }, {
    key: "dispose",
    value: function dispose() {
      if (this._contextMenuIsBeingShownCount > 0) {
        this._contextViewService.hideContextView();
      }

      this._toDispose.dispose();
    }
  }], [{
    key: "get",
    value: function get(editor) {
      return editor.getContribution(ContextMenuController.ID);
    }
  }]);

  return ContextMenuController;
}();

ContextMenuController.ID = 'editor.contrib.contextmenu';
ContextMenuController = __decorate([__param(1, IContextMenuService), __param(2, IContextViewService), __param(3, IContextKeyService), __param(4, IKeybindingService), __param(5, IMenuService)], ContextMenuController);
export { ContextMenuController };

var ShowContextMenu = /*#__PURE__*/function (_EditorAction) {
  _inherits(ShowContextMenu, _EditorAction);

  var _super = _createSuper(ShowContextMenu);

  function ShowContextMenu() {
    _classCallCheck(this, ShowContextMenu);

    return _super.call(this, {
      id: 'editor.action.showContextMenu',
      label: nls.localize('action.showContextMenu.label', "Show Editor Context Menu"),
      alias: 'Show Editor Context Menu',
      precondition: undefined,
      kbOpts: {
        kbExpr: EditorContextKeys.textInputFocus,
        primary: 1024
        /* Shift */
        | 68
        /* F10 */
        ,
        weight: 100
        /* EditorContrib */

      }
    });
  }

  _createClass(ShowContextMenu, [{
    key: "run",
    value: function run(accessor, editor) {
      var contribution = ContextMenuController.get(editor);
      contribution.showContextMenu();
    }
  }]);

  return ShowContextMenu;
}(EditorAction);

registerEditorContribution(ContextMenuController.ID, ContextMenuController);
registerEditorAction(ShowContextMenu);